var map = {
	"./cognito-redux/reducer.js": "./src/cognito-redux/reducer.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src recursive reducer.js";


//////////////////
// WEBPACK FOOTER
// ./src reducer.js
// module id = ./src recursive reducer.js
// module chunks = 1